export default __webpack_public_path__ + "static/media/history.ko-1.5d77b166.png";